export const AGG_CONFLUENCE_SPACE_SEARCH_URL = `/gateway/api/graphql`;

export const getSearchConfluenceSpacesGraphqlPayload = ({
	cloudId,
	queryString,
	limit,
}: {
	cloudId: string;
	queryString: string;
	limit: number;
}) =>
	JSON.stringify({
		query: `query SearchConfluenceSpacesQuery {
			search {
			  search(
				experience: "link-create.confluence-form",
				query: "${queryString}",
				last: ${limit},
				filters: {
				  entities: "ati:cloud:confluence:space",
				  locations: "ari:cloud:confluence::site/${cloudId}"
				}) {
				edges {
				  node {
					title
					... on SearchConfluenceSpace {
					  spaceEntity {
						key
						alias
						id
						icon {
							path
						}
						links {
							base
							webUi
						}
						typeSettings {
							enabledContentTypes {
								isLivePagesEnabled
							}
						}
					  }
					}
				  }
				}
			  }
			}
		  }`,
		operationName: 'SearchConfluenceSpacesQuery',
	});
